$('#lucky_secure_form').on('submit', function (e) {
    e.preventDefault();
    $(this).find('.alert-success').empty();
    $(this).find('.alert-success').hide();
    $('#error ul li').remove();
    $('#error').hide();
    var city = $(this).find('#province').val();
    var title = $(this).find('input[name="title"]:checked').val();
    var fname = $(this).find('#frist-name').val();
    var lname = $(this).find('#last-name').val();
    var email = $(this).find('#email').val();
    var phone = $(this).find('#contact-number').val();
    var msg = $(this).find('#comments').val();
    var model = $(this).find('#model').val();
    var kitemail = $('#formemail').is(':checked');
    var kitphone = $('#formphone').is(':checked');
    var kitpost = $('#formpost').is(':checked');
    var kitpostaddress = kitpost ? $(this).find('#keepintouchfulladdress').val() : false;
    var lucky_secure = $(this).find('#lucky_secure').val();
    var dealer = $(this).find('#dealer').val();
    var validation = true;
    var form = $(this);
    var otherCity = false;
    if(city=='other'){
        city = $(this).find('#other-city-input').val();
        otherCity = true;
    }

    form.find('.lucky-secure-btn').addClass('loading');
    form.find('.lucky-secure-btn').attr('disabled', true);
    form.find('.lucky-secure-btn').html('<span>Submiting</span>');

    var g_recaptcha_response =grecaptcha.getResponse();
    var ajax_url = ajax_object.ajax_url;

    if (validation) {
        $.ajax({
            method: 'POST',
            url: ajax_url,
            data: {
                action: 'luckysecureform',
                city: city,
                title: title,
                fname: fname,
                lname: lname,
                email: email,
                phone: phone,
                msg: msg,
                model: model,
                kitemail: kitemail,
                kitphone: kitphone,
                kitpost: kitpost,
                g_recaptcha_response: g_recaptcha_response,
                lucky_secure: lucky_secure,
                dealer: dealer,
                otherCity:otherCity
            },
            success: function (response) {
                const res = response.data;
                if (res.status == 1) {
                    form.trigger('reset');
                    form.find('.alert-success').show();
                    form.find('.alert-success').text(res.message);

                } else {
                    if(res.html){
                        $('#error').html(res.html);
                    } else if(res.message){
                        $('#error').html(res.message);
                    }
                    
                    $('#error').show();
                    $('html, body').animate({
                        scrollTop: form.offset().top,
                    }, 2000);
                }

                form.find('.lucky-secure-btn').removeClass('loading');
                form.find('.lucky-secure-btn').removeAttr('disabled');
                form.find('.lucky-secure-btn').html('<span>Send My Request</span>');
            },
            error: function(xhr, status, error) {
                // Handle error
                $(window).scrollTop(0);
                form.find('.lucky-secure-btn').removeClass('loading');
                form.find('.lucky-secure-btn').removeAttr('disabled');
                form.find('.lucky-secure-btn').html('<span>Send My Request</span>');
            }
        });
    }
});


// WEBPACK FOOTER //
// ./scripts/routes/templateLuckySecure.js